import type { SingleFilter } from 'shared/filter/types';
export interface FilterMapped {
  path: string;
  type: string;
  value?: any;
}

const filtersMap: Record<string, FilterMapped> = {
  subcontractors: {
    path: 'primaryData.subcontractors',
    type: 'oneOfDirect',
  },
  executor: {
    path: 'primaryData.executor',
    type: 'direct',
  },
  createdBy: {
    path: 'createdBy',
    type: 'direct',
  },
  issueTypes: {
    path: 'process',
    type: 'direct',
  },
  createdAt: {
    path: 'createdAt',
    type: 'dateRange',
  },
  detectionDate: {
    path: 'primaryData.detectionDate',
    type: 'dateRange',
  },
  stage: {
    path: 'stageId',
    type: 'direct',
  },
  site: {
    path: 'primaryData.site',
    type: 'direct',
  },
  contractNumbers: {
    path: 'primaryData.contractNumbers',
    type: 'oneOfDirect',
  },
  assignee: {
    path: 'primaryData.assignee',
    type: 'direct',
  },
  level: {
    path: 'primaryData.level',
    type: 'direct',
  },
  workTypes: {
    path: 'extendedData.workTypes',
    type: 'oneOfDirect',
  },
  rootCauses: {
    path: 'extendedData.rootCauses',
    type: 'oneOfDirect',
  },
  environmentalAspect: {
    path: 'extendedData.environmentalAspect',
    type: 'direct',
  },
  impact: {
    path: 'extendedData.impact',
    type: 'direct',
  },
  priority: {
    path: 'extendedData.priority',
    type: 'direct',
  },
  projectStage: {
    path: 'extendedData.projectStage',
    type: 'direct',
  },
  circumstances: {
    path: 'extendedData.circumstances',
    type: 'direct',
  },
  issueVerification: {
    path: 'extendedData.issueVerification',
    type: 'direct',
  },
  delayReason: {
    path: 'extendedData.delayReason',
    type: 'direct',
  },
  rejectionReason: {
    path: 'extendedData.rejectionReason',
    type: 'direct',
  },
  spilledSubstance: {
    path: 'extendedData.spilledSubstance',
    type: 'direct',
  },
  proposedCorrectiveAction: {
    path: 'extendedData.proposedCorrectiveAction',
    type: 'direct',
  },
  effect: {
    path: 'extendedData.effect',
    type: 'direct',
  },
  hazardCategory: {
    path: 'extendedData.hazardCategory',
    type: 'oneOfDirect',
  },
  decisionToImposeFine: {
    path: 'extendedData.decisionToImposeFine',
    type: 'direct',
  },
  targetCompletionDate: {
    path: 'extendedData.targetCompletionDate',
    type: 'dateRange',
  },
  finalCompletionDate: {
    path: 'extendedData.finalCompletionDate',
    type: 'dateRange',
  },
  targetResponseToAuthorDate: {
    path: 'extendedData.targetResponseToAuthorDate',
    type: 'dateRange',
  },
  finalResponseToAuthorDate: {
    path: 'extendedData.finalResponseToAuthorDate',
    type: 'dateRange',
  },
  finalStartDate: {
    path: 'extendedData.finalStartDate',
    type: 'dateRange',
  },
  targetStartDate: {
    path: 'extendedData.targetStartDate',
    type: 'dateRange',
  },
  inspection: {
    path: 'inspection',
    type: 'direct',
  },
  executedByCompanies: {
    path: 'extendedData.executedByCompanies',
    type: 'oneOfDirect',
  },
  supervisor: {
    path: 'extendedData.supervisor',
    type: 'direct',
  },
  employmentType: {
    path: 'extendedData.employmentType',
    type: 'direct',
  },
  injuryTypes: {
    path: 'extendedData.injuryTypes',
    type: 'oneOfDirect',
  },
  injuredBodyParts: {
    path: 'extendedData.injuredBodyParts',
    type: 'oneOfDirect',
  },
  requirements: {
    path: 'extendedData.requirements',
    type: 'oneOfDirect',
  },
  installationBasis: {
    path: 'extendedData.installationBasis',
    type: 'oneOfDirect',
  },
  constructionProductDocuments: {
    path: 'extendedData.constructionProductDocuments',
    type: 'oneOfDirect',
  },
  deviceDocuments: {
    path: 'extendedData.deviceDocuments',
    type: 'oneOfDirect',
  },
  additionalDocuments: {
    path: 'extendedData.additionalDocuments',
    type: 'oneOfDirect',
  },
  sickLeaveStartDate: {
    path: 'extendedData.sickLeaveStartDate',
    type: 'dateRange',
  },
  sickLeaveEndDate: {
    path: 'extendedData.sickLeaveEndDate',
    type: 'dateRange',
  },
  search: {
    path: '',
    type: 'search',
  },
};

interface OldFilter {
  name: string;
  value:
    | { _id?: string }[]
    | { fromDate: string | null; toDate: string | null }
    | string;
}

export const standariseFilters = (
  filters: OldFilter[]
): FilterMapped[] => {
  return filters.map((filter) => {
    const mapped = filtersMap[filter.name] || undefined;
    return mapped
      ? { ...mapped, value: filter.value }
      : { path: '', type: 'invalid' };
  });
};

/**
 * The filters the filtering applies. Only an invalid entry (an unknown filter
 * name) has no value, and the filtering would skip it anyway.
 */
export function toSingleFilters(filters: FilterMapped[]): SingleFilter[] {
  return filters.filter((filter): filter is SingleFilter => filter.value !== undefined);
}
